module.exports = __webpack_public_path__ + "img/shop02.89962d93.png";